import { Button } from "@mui/material";
import { useIntercom } from "react-use-intercom";

interface SupportButtonProps {
  text?: string;
  variant?: "text" | "outlined" | "contained";
}

const SupportButton = (props: SupportButtonProps) => {
  const { show } = useIntercom();

  return (
    <Button
      variant={props.variant ? props.variant : "text"}
      onClick={() => show()}
    >
      {props.text ? props.text : "Contact Us"}
    </Button>
  );
};

export { SupportButton };
